window.avenseAddToCart = function(source) {
    var productId = $("#product-id").val();

    if (productId && window.avenseAppendBoxItems) {
        var array = window.avenseAppendBoxItems.split(",").filter(n => n !== "")

        if (array.includes(productId)) {
            // ! Here we should add an item to cart
        }
    }
}